import {
    getProduct,
    listProducts
} from './queries';
import {GraphQLQuery} from '@aws-amplify/api';
import {
    GetProduct,
    ListProducts
} from "../types";
import {notifyError} from "../../../../components/ServiceNotifications";
import {billingClient} from '../../billing-api-integration/client';

export type {Product} from '../types';

export const fetchProducts = async (variables?: Record<string, any>) => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<ListProducts>>({
                                                                              query: listProducts,
                                                                              variables: {...variables},
                                                                          });
        return response.data?.listProducts ?? { items: [], nextToken: '' };
    } catch (e) {
        notifyError(e);
        return { items: [], nextToken: '' };
    }
};

export const fetchProduct = async (id: string) => {
    try {
        const response = await billingClient.graphql<GraphQLQuery<GetProduct>>({
                                                                            query: getProduct,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getProduct ?? null;
    } catch (e) {
        notifyError(e);
        return null;
    }
};


